export default __webpack_public_path__ + "linkedin.fae0b6ba4e5e6a91409e99f2ede7f21c.svg";